const translation = {
  siteName: '反差设计研究所',
  siteTagline: '视觉与情感的极致碰撞',
  navHome: '首页',
  navCategories: '分类',
  navAbout: '关于我们',
  readMore: '阅读全文',
  featuredArticles: '精选文章',
  trendingArticles: '热门文章',
  allCategories: '全部分类',
  relatedArticles: '相关文章',
  aboutUs: '关于我们',
  contactUs: '联系我们',
  subscribe: '订阅',
  footerDescription: '反差设计研究所——专注探索反差美学在视觉设计、摄影、文案与品牌营销中的无限可能。',
  copyright: '© 2026 反差设计研究所. All rights reserved.',
  backToHome: '返回首页',
  scrollToTop: '回到顶部',
  authorPrefix: '作者',
  readTimeUnit: '分钟阅读',
  breadcrumbHome: '首页',
};

export default translation;